export default __webpack_public_path__ + "static/media/DXC_logo.86b64470.png";